<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-07-13 08:36:03
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-06 16:50:37
-->
<template>
  <div :color="['#08488A']" class="container">
    <div class="title">
      学校累计采购金额（元）
      <span class="stats-link" @click="showStatsDialog">统计字段说明</span>
    </div>
    <div :class="['count', { highlight: isHighlight }]">
      <div class="box-item">
        <li
          v-for="(item, index) in numArr"
          :key="index"
          :class="{ 'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
        >
          <span v-if="!isNaN(item)">
            <i ref="numberItem">0123456789</i>
          </span>
          <span v-else class="comma">{{ item }}</span>
        </li>
      </div>
    </div>
    <!-- 统计字段说明弹窗 -->
    <StatsFieldDialog ref="statsDialog" />
  </div>
</template>

<script>
import StatsFieldDialog from './StatsFieldDialog'

export default {
  name: 'Flop',
  components: { StatsFieldDialog },
  data() {
    return {
      numArr: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      num: 0,
      isHighlight: false,
    }
  },
  methods: {
    async initData(data) {
      if (this.num != data) {
        this.isHighlight = true
        setTimeout(() => {
          this.isHighlight = false
        }, 2000)
      }
      this.num = data
      this.toOrderNum(this.num)
      this.$nextTick(() => {
        this.setNumberTransform()
      })
    },
    // 设置文字滚动
    setNumberTransform() {
      const numberItems = this.$refs.numberItem
      const numberArr = this.numArr.filter(item => !isNaN(item))
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum(num) {
      num = num.toString()
      if (num.length < 9) {
        num = '0' + num
        this.toOrderNum(num)
      } else if (num.length === 9) {
        this.numArr = num.split('')
      }
    },
    showStatsDialog() {
      this.$refs.statsDialog.show()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
  height: 100%;
  padding-top: 38px;

  .title {
    height: 43px;
    line-height: 43px;
    font-weight: bold;
    font-size: 43px;
    color: #00fff4;
    text-align: center;
    margin-bottom: 37px;
    position: relative;

    .stats-link {
      position: absolute;
      right: 30px;
      top: 0;
      font-size: 16px;
      color: #00c0fe;
      cursor: pointer;
      transition: all 0.3s;
      font-weight: normal;

      &:hover {
        color: #66ffff;
        text-decoration: underline;
      }
    }
  }

  .count {
    transition: transform 0.5s ease, color 0.5s ease;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 800;

    .box-item {
      letter-spacing: 3px;
      writing-mode: vertical-lr;
      text-orientation: upright;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      -khtml-user-select: none;
      user-select: none;
    }

    .mark-item {
      width: 20px;
      height: 100px;
      line-height: 100px;
      font-size: 30px;
      position: relative;

      & > span {
        position: absolute;
        width: 100%;
        right: 42px;
        bottom: 0;
      }
    }

    .number-item {
      transition: transform 0.5s ease, color 0.5s ease;
      width: 103px;
      height: 99px;
      line-height: 99px;
      font-size: 72px;
      font-weight: 700;
      margin-right: 30px;
      background: url('~@/img/datav-tc/num_bg.png');
      list-style: none;
      color: #00fff4;

      & > span {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        writing-mode: vertical-rl;
        text-orientation: upright;
        overflow: hidden;

        & > i {
          font-style: normal;
          position: absolute;
          top: 15px;
          left: 50%;
          transform: translate(-50%, 0);
          transition: transform 2s ease-in-out;
          letter-spacing: 15px;
        }
      }
    }

    &.highlight {
      .number-item {
        transform: scale(1.2);
        color: #ffcc00;
      }
    }

    .number-item:last-child {
      margin-right: 0;
    }
  }
}
</style>
